import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface OpcionesCargaData {
  nombreArchivo: string;
  periodo: string;
}

export interface OpcionesCargaResult {
  tipo: 'NUEVA' | 'REEMPLAZAR';
  periodo: string;
  confirmado: boolean;
}

@Component({
  selector: 'app-opciones-carga-dialog',
  templateUrl: './opciones-carga-dialog.component.html',
  styleUrls: ['./opciones-carga-dialog.component.scss']
})
export class OpcionesCargaDialogComponent {
  opcionSeleccionada: 'NUEVA' | 'REEMPLAZAR' | null = null;

  constructor(
    public dialogRef: MatDialogRef<OpcionesCargaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OpcionesCargaData
  ) {}

  confirmar(): void {
    if (this.opcionSeleccionada) {
      this.dialogRef.close({
        tipo: this.opcionSeleccionada,
        periodo: this.data.periodo,
        confirmado: true
      });
    }
  }

  cancelar(): void {
    this.dialogRef.close({
      confirmado: false
    });
  }
}
